var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.15659 2.68682H4.81685C3.48083 2.68682 2.81281 2.68682 2.30252 2.94683C1.85366 3.17554 1.48872 3.54048 1.26001 3.98935C1 4.49964 1 5.16765 1 6.50367V13.1832C1 14.5192 1 15.1872 1.26001 15.6975C1.48872 16.1463 1.85366 16.5113 2.30252 16.74C2.81281 17 3.48083 17 4.81685 17H11.4963C12.8324 17 13.5004 17 14.0107 16.74C14.4595 16.5113 14.8245 16.1463 15.0532 15.6975C15.3132 15.1872 15.3132 14.5192 15.3132 13.1832V9.84341M5.77104 12.2289H7.10259C7.49158 12.2289 7.68607 12.2289 7.8691 12.185C8.03138 12.146 8.18651 12.0818 8.3288 11.9946C8.48929 11.8962 8.62682 11.7587 8.90187 11.4837L16.5059 3.87959C17.1647 3.22084 17.1647 2.15281 16.5059 1.49406C15.8472 0.835314 14.7792 0.835313 14.1204 1.49406L6.51633 9.09813C6.24127 9.37318 6.10374 9.51071 6.00539 9.6712C5.9182 9.81349 5.85394 9.96862 5.81498 10.1309C5.77104 10.3139 5.77104 10.5084 5.77104 10.8974V12.2289Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d4fa3960.svg";
export { ForwardRef as ReactComponent };